import { render, staticRenderFns } from "./btn-primary.vue?vue&type=template&id=46a9a51e"
import script from "./btn-primary.vue?vue&type=script&lang=js"
export * from "./btn-primary.vue?vue&type=script&lang=js"
import style0 from "./btn-primary.vue?vue&type=style&index=0&id=46a9a51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
